<div class="wallet-card" [ngClass]="{ inactive: isActive === false, clickable: isClickable === true }">
  <!-- Pending Badge -->
  @if (pending) {
    <div class="pending-badge">Pending</div>
  }
  <div class="wallet-name">
    <div class="wallet-icon">
      @if (networkIcon) {
        <img [src]="networkIcon" [alt]="networkName" class="wallet-logo" (error)="networkIconMissing = true" />
      } @else {
        <div class="wallet-logo-placeholder">
          <span>{{ networkName.charAt(0) }}</span>
        </div>
      }
    </div>
    <span
      [matTooltip]="name"
      [matTooltipDisabled]="!isNameOverflowing"
      matTooltipPosition="above"
      #walletName
      class="wallet-name-text"
      >
      {{ name }}
    </span>
    <div class="wallet-name-icons">
      @if (showLifecycleBadge) {
        <span
          class="lifecycle-badge"
          [ngClass]="isServing ? 'lifecycle-serving' : 'lifecycle-' + lifecycleBadge"
          [matTooltip]="lifecycleTooltip"
          matTooltipPosition="above"
          >
          @if (isServing) {
            <img src="shared-assets/icons/lifecycle-draining.svg" alt="Serving" />
            @if (lifecycleBadge === 'active' || lifecycleBadge === 'capped') {
              <span class="lifecycle-dot" [ngClass]="'dot-' + lifecycleBadge"></span>
            }
          } @else {
            @switch (lifecycleBadge) {
              @case ('active') {
                <img src="shared-assets/icons/lifecycle-active.svg" alt="Active" />
              }
              @case ('capped') {
                <mat-icon>lock</mat-icon>
              }
              @case ('closed') {
                <mat-icon>close</mat-icon>
              }
              @case ('serving') {
                <img src="shared-assets/icons/lifecycle-draining.svg" alt="Serving" />
              }
            }
          }
        </span>
      }
      @if (showRiskLevel) {
        <span class="risk-badge" [matTooltip]="riskToolTip(risk)" matTooltipPosition="above">
          <span class="warning-icon" [ngClass]="'risk-' + (risk || 'not-assessed')"></span>
        </span>
      }
    </div>
  </div>
  <div class="wallet-address">
    <span class="olv-address" [matTooltip]="address" matTooltipPosition="above">
      {{ getFormattedAddress() }}
    </span>
    <button
      type="button"
      class="copy-icon"
      aria-label="Copy address"
      matTooltip="{{ tooltipText }}"
      #tooltip="matTooltip"
      matTooltipPosition="above"
      (click)="copyToClipboard($event)"
      (keydown)="$event.stopPropagation()"
      >
      <img src="shared-assets/icons/copy.svg" width="12" height="14" alt="Copy Icon" />
    </button>
  </div>

  @if (showAmountRows) {
    <div class="wallet-currencies">
      @for (row of amountRows; track row.label) {
        <div class="wallet-currency" [class.highlight]="row.highlight">
          <span class="currency-name">{{ row.label }}</span>
          <span class="currency-amount">
            {{ row.amount | formatCoinCurrency: currencies[0]?.displayPrecision }} {{ currencies[0]?.name }}
          </span>
        </div>
      }
    </div>
  } @else if (currencies.length) {
    <div class="wallet-currencies">
      @for (currency of currencies; track currency.name) {
        <div class="wallet-currency">
          <span class="currency-name">{{ currency.name }}</span>
          <span class="currency-amount">{{ currency.amount | formatCoinCurrency: currency.displayPrecision }}</span>
        </div>
      }
    </div>
  }
</div>
